module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DIV', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingSpinner),
      expression: "loadingSpinner"
    }],
    staticClass: "content-wrapper",
    attrs: {
      "element-loading-text": "Подождите"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "float": "left"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "16px",
      "padding-top": "0px"
    }
  }, [_vm._v("Клиенты")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "-5px",
      "padding-left": "5px",
      "float": "left"
    }
  }, [_c('Button', {
    staticStyle: {
      "border-radius": "3px",
      "margin-bottom": "5px",
      "padding-top": "5px"
    },
    attrs: {
      "type": "text",
      "size": "small"
    },
    on: {
      "click": _vm.reloadOnClick
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-loop",
      "size": "18"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin": "0 10px 0 7px",
      "display": "inline-block"
    }
  }, [_c('Button', {
    staticStyle: {
      "border-radius": "3px",
      "height": "36px",
      "margin-bottom": "0px",
      "color": "#b7b7b7",
      "text-decoration2": "underline"
    },
    attrs: {
      "type": "dashed",
      "size2": "large"
    },
    on: {
      "click": _vm.showDeletedItemsChangeMode
    }
  }, [(_vm.showDeletedItemsMode == false) ? _c('span', [_vm._v("АРХИВ")]) : _c('span', [_vm._v("ВЕРНУТЬСЯ ИЗ АРХИВА")])])], 1)]), _vm._v(" "), (_vm.commonData.isLoaded == false) ? _c('div', [_vm._v("\n  Подождите, загружаются общие данные\n")]) : (_vm.dataIsLoaded == false) ? _c('div', [_vm._v("\n  Подождите, загружаются данные по клиентам\n")]) : _c('div', {
    staticStyle: {
      "width": "100%",
      "float": "left"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "100%",
      "padding-right": "0px",
      "float": "left"
    },
    style: (_vm.expandTable == true ? 'width:100%' : 'width:calc(100% - 370px)')
  }, [_c('div', {
    staticStyle: {
      "width": "50px",
      "padding-top": "11px",
      "padding-bottom": "0px",
      "display": "inline-block",
      "float": "left"
    }
  }, [_c('span', [_vm._v("Фильтр")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-bottom": "12px",
      "display": "inline-block",
      "width": "300px"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "size": "large"
    },
    on: {
      "on-change": _vm.filterValueOnChange
    },
    model: {
      value: (_vm.filterValue),
      callback: function($$v) {
        _vm.filterValue = $$v
      },
      expression: "filterValue"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "float2": "right",
      "margin": "0 10px 0 7px",
      "display": "inline-block"
    }
  }, [_c('Button', {
    staticStyle: {
      "border-radius": "3px",
      "height": "36px",
      "margin-bottom": "0px"
    },
    attrs: {
      "type": "ghost",
      "size": "large",
      "disabled": (_vm.editingDataRow != null) && (_vm.editingDataRow.val.id == null)
    },
    on: {
      "click": _vm.newEditingDataRowOnClick
    }
  }, [_vm._v("+")])], 1), _vm._v(" "), (_vm.showDeletedItemsMode == true) ? _c('div', {
    staticStyle: {
      "font-size": "15px",
      "padding-bottom": "10px"
    }
  }, [_vm._v("\n    АРХИВ КЛИЕНТОВ:\n  ")]) : _vm._e(), _vm._v(" "), (_vm.filteredRecords.length > 0) ? _c('div', [_vm._l((_vm.filteredRecords), function(itemData, keyData) {
    return _c('div', {
      key: keyData,
      staticStyle: {
        "width": "350px",
        "height": "180px",
        "padding": "20px",
        "margin": "0 10px 10px 0",
        "border-radius": "10px",
        "float": "left"
      },
      style: ({
        border: _vm.isRowSelected(itemData) == true ? '1px solid #bbb' : '1px solid #ccc',
        color: _vm.isRowSelected(itemData) == true ? '#fff' : '#778087',
        background: _vm.isRowSelected(itemData) === true ? '#a0a7ff' : (itemData.val.ClientOrSupplier !== 1 ? '#cccce0' : (itemData.val.PersonOrCompany === 1 ? '#cec' : '#eee'))
      }),
      on: {
        "click": function($event) {
          _vm.dataRowOnSelect(itemData)
        }
      }
    }, [_c('div', {
      staticStyle: {
        "margin": "0px 0 10px 0",
        "padding-bottom": "5px",
        "display": "inline-block",
        "float": "left",
        "width": "calc(100% - 20px)"
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "18px"
      }
    }, [_c('b', [_vm._v(_vm._s(itemData.val.Name) + " ")])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "padding-bottom": "5px",
        "display": "inline-block",
        "clear": "left",
        "width": "20px"
      }
    }, [(itemData.val.PersonOrCompany === 2) ? _c('div', [_c('Icon', {
      staticStyle: {
        "font-size": "19px"
      },
      attrs: {
        "type": "briefcase"
      }
    })], 1) : _c('div', [_c('Icon', {
      staticStyle: {
        "font-size": "19px"
      },
      attrs: {
        "type": "android-contact"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "120px",
        "padding-top": "0px",
        "padding-bottom": "0px",
        "display": "inline-block",
        "float": "left"
      }
    }, [_c('span', [_vm._v("ИНН")])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "padding-bottom": "5px",
        "display": "inline-block",
        "clear": "left",
        "width": "calc(100% - 120px)"
      }
    }, [_c('span', [_vm._v(_vm._s(itemData.val.INN) + " ")])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "120px",
        "padding-top": "0px",
        "padding-bottom": "0px",
        "display": "inline-block",
        "float": "left"
      }
    }, [_c('span', [_vm._v("Телефон")])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "padding-bottom": "5px",
        "display": "inline-block",
        "clear": "left",
        "width": "calc(100% - 120px)"
      }
    }, [_c('span', [_vm._v(_vm._s(itemData.val.Phone) + " ")])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "120px",
        "padding-top": "0px",
        "padding-bottom": "0px",
        "display": "inline-block",
        "float": "left"
      }
    }, [(itemData.val.PersonOrCompany === 2) ? _c('span', [_vm._v("Контактное лицо")]) : _vm._e(), _vm._v(" ")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "padding-bottom": "5px",
        "display": "inline-block",
        "clear": "left",
        "width": "calc(100% - 120px)"
      }
    }, [(itemData.val.PersonOrCompany === 2) ? _c('span', [_vm._v(_vm._s(itemData.val.ContactName))]) : _vm._e(), _vm._v(" ")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "120px",
        "padding-top": "0px",
        "padding-bottom": "0px",
        "display": "inline-block",
        "float": "left"
      }
    }, [_c('span', [_vm._v("Город")])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "padding-bottom": "5px",
        "display": "inline-block",
        "clear": "left",
        "width": "calc(100% - 120px)"
      }
    }, [_c('span', [_vm._v(_vm._s(itemData.val.City) + " ")])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "120px",
        "padding-top": "0px",
        "padding-bottom": "0px",
        "display": "inline-block",
        "float": "left"
      }
    }, [_c('span', [_vm._v("Адрес")])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "padding-bottom": "5px",
        "display": "inline-block",
        "clear": "left",
        "width": "calc(100% - 120px)"
      }
    }, [_c('span', [_vm._v(_vm._s(itemData.val.Address) + " ")])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "5px",
        "padding-bottom": "5px",
        "display": "inline-block",
        "clear": "left",
        "width": "100%"
      }
    }, [(itemData.val.ClientOrSupplier !== 1) ? _c('span', {
      staticStyle: {
        "float": "right"
      }
    }, [_c('b', [_vm._v("ПОСТАВЩИК")])]) : _vm._e(), _vm._v(" \n    ")])])
  }), _vm._v(" "), (_vm.filteredRecords.length == _vm.numOfItemsToShowWithEmptyFilter) ? _c('div', {
    staticStyle: {
      "clear": "left"
    }
  }, [_vm._v("\n     * Список не полный, еще много всего найдено. Используйте фильтр, чтобы увидеть необходимые данные. Минимум 3 символа.\n   ")]) : _vm._e()], 2) : _c('div', [_vm._v("\n    * Ничего не найдено. Скорректируйте фильтр, чтобы увидеть необходимые данные. Минимум 3 символа.\n  ")])]), _vm._v(" "), _c('div', {
    class: (_vm.expandTable == true) ? 'hidden' : '',
    staticStyle: {
      "width": "370px",
      "padding": "44px 0px 10px 20px",
      "border-left": "1px solid #ccc",
      "float": "left",
      "min-height": "calc(100vh - 130px)"
    }
  }, [(_vm.editingDataRow != null) ? _c('div', [_c('div', {
    staticStyle: {
      "width": "100%",
      "padding-top": "5px",
      "padding-bottom": "20px",
      "display": "inline-block",
      "float": "left"
    }
  }, [(_vm.editingDataRow.val.id != null) ? _c('span', [_c('b', [_vm._v("РЕДАКТИРОВАНИЕ :")])]) : _c('span', [_c('b', [_vm._v("НОВЫЙ КЛИЕНТ :")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100px",
      "padding-top": "3px",
      "padding-bottom": "10px",
      "display": "inline-block",
      "float": "left"
    }
  }, [_c('span', [_vm._v("Имя")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-bottom": "10px",
      "display": "inline-block",
      "clear": "left",
      "width": "calc(100% - 100px)"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "100%"
    },
    model: {
      value: (_vm.editingDataRow.val.Name),
      callback: function($$v) {
        _vm.editingDataRow.val.Name = $$v
      },
      expression: "editingDataRow.val.Name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100px",
      "padding-top": "3px",
      "padding-bottom": "10px",
      "display": "inline-block",
      "float": "left"
    }
  }, [_c('span', [_vm._v("Человек / компания")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-bottom": "10px",
      "display": "inline-block",
      "clear": "left",
      "width": "calc(100% - 100px)"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editingDataRow.val.PersonOrCompany),
      expression: "editingDataRow.val.PersonOrCompany"
    }],
    staticStyle: {
      "width": "100%",
      "height": "32px",
      "background-color": "#fff"
    },
    attrs: {
      "filterable": "",
      "placeholder": "Выберите"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.editingDataRow.val.PersonOrCompany = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Человек")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Компания")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100px",
      "padding-top": "3px",
      "padding-bottom": "10px",
      "display": "inline-block",
      "float": "left"
    }
  }, [_c('span', [_vm._v("Клиент / поставщик")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-bottom": "10px",
      "display": "inline-block",
      "clear": "left",
      "width": "calc(100% - 100px)"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editingDataRow.val.ClientOrSupplier),
      expression: "editingDataRow.val.ClientOrSupplier"
    }],
    staticStyle: {
      "width": "100%",
      "height": "32px",
      "background-color": "#fff"
    },
    attrs: {
      "filterable": "",
      "placeholder": "Выберите"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.editingDataRow.val.ClientOrSupplier = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Клиент и поставщик")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Клиент")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Поставщик")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100px",
      "padding-top": "3px",
      "padding-bottom": "10px",
      "display": "inline-block",
      "float": "left"
    }
  }, [_c('span', [_vm._v("ИНН")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-bottom": "10px",
      "display": "inline-block",
      "clear": "left",
      "width": "calc(100% - 100px)"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "100%"
    },
    model: {
      value: (_vm.editingDataRow.val.INN),
      callback: function($$v) {
        _vm.editingDataRow.val.INN = $$v
      },
      expression: "editingDataRow.val.INN"
    }
  })], 1), _vm._v(" "), (_vm.editingDataRow.val.PersonOrCompany == 2) ? _c('div', [_c('div', {
    staticStyle: {
      "width": "100px",
      "padding-top": "3px",
      "padding-bottom": "10px",
      "display": "inline-block",
      "float": "left"
    }
  }, [_c('span', [_vm._v("ОГРНН")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-bottom": "10px",
      "display": "inline-block",
      "clear": "left",
      "width": "calc(100% - 100px)"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "100%"
    },
    model: {
      value: (_vm.editingDataRow.val.OGRNN),
      callback: function($$v) {
        _vm.editingDataRow.val.OGRNN = $$v
      },
      expression: "editingDataRow.val.OGRNN"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100px",
      "padding-top": "3px",
      "padding-bottom": "10px",
      "display": "inline-block",
      "float": "left"
    }
  }, [_c('span', [_vm._v("КПП")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-bottom": "10px",
      "display": "inline-block",
      "clear": "left",
      "width": "calc(100% - 100px)"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "100%"
    },
    model: {
      value: (_vm.editingDataRow.val.KPP),
      callback: function($$v) {
        _vm.editingDataRow.val.KPP = $$v
      },
      expression: "editingDataRow.val.KPP"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100px",
      "padding-top": "3px",
      "padding-bottom": "10px",
      "display": "inline-block",
      "float": "left"
    }
  }, [_c('span', [_vm._v("Телефон")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-bottom": "10px",
      "display": "inline-block",
      "clear": "left",
      "width": "calc(100% - 100px)"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "100%"
    },
    model: {
      value: (_vm.editingDataRow.val.Phone),
      callback: function($$v) {
        _vm.editingDataRow.val.Phone = $$v
      },
      expression: "editingDataRow.val.Phone"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100px",
      "padding-top": "3px",
      "padding-bottom": "10px",
      "display": "inline-block",
      "float": "left"
    }
  }, [_c('span', [_vm._v("Email")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-bottom": "10px",
      "display": "inline-block",
      "clear": "left",
      "width": "calc(100% - 100px)"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "100%"
    },
    model: {
      value: (_vm.editingDataRow.val.Email),
      callback: function($$v) {
        _vm.editingDataRow.val.Email = $$v
      },
      expression: "editingDataRow.val.Email"
    }
  })], 1), _vm._v(" "), (_vm.editingDataRow.val.PersonOrCompany == 2) ? _c('div', [_c('div', {
    staticStyle: {
      "width": "100px",
      "padding-top": "3px",
      "padding-bottom": "10px",
      "display": "inline-block",
      "float": "left"
    }
  }, [_c('span', [_vm._v("Контактное"), _c('br'), _vm._v("лицо")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-bottom": "10px",
      "display": "inline-block",
      "clear": "left",
      "width": "calc(100% - 100px)"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "100%"
    },
    model: {
      value: (_vm.editingDataRow.val.ContactName),
      callback: function($$v) {
        _vm.editingDataRow.val.ContactName = $$v
      },
      expression: "editingDataRow.val.ContactName"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100px",
      "padding-top": "3px",
      "padding-bottom": "10px",
      "display": "inline-block",
      "float": "left"
    }
  }, [_c('span', [_vm._v("Город")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-bottom": "10px",
      "display": "inline-block",
      "clear": "left",
      "width": "calc(100% - 100px)"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "100%"
    },
    model: {
      value: (_vm.editingDataRow.val.City),
      callback: function($$v) {
        _vm.editingDataRow.val.City = $$v
      },
      expression: "editingDataRow.val.City"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100px",
      "padding-top": "3px",
      "padding-bottom": "10px",
      "display": "inline-block",
      "float": "left"
    }
  }, [_c('span', [_vm._v("Адрес")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-bottom": "10px",
      "display": "inline-block",
      "clear": "left",
      "width": "calc(100% - 100px)"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "100%"
    },
    model: {
      value: (_vm.editingDataRow.val.Address),
      callback: function($$v) {
        _vm.editingDataRow.val.Address = $$v
      },
      expression: "editingDataRow.val.Address"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100px",
      "padding-top": "3px",
      "padding-bottom": "10px",
      "display": "inline-block",
      "float": "left"
    }
  }, [_c('span', [_vm._v("Идентификатор")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "3px",
      "padding-bottom": "10px",
      "display": "inline-block",
      "clear": "left",
      "width": "calc(100% - 100px)"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.editingDataRow.val.id) + " \n      ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "15px 0px 0px 0px"
    }
  }, [_c('Button', {
    staticStyle: {
      "border-radius": "3px",
      "margin-bottom": "10px"
    },
    attrs: {
      "type": "warning"
    },
    on: {
      "click": _vm.saveEditingDataRowOnClick
    }
  }, [_vm._v("Сохранить")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "border-radius": "3px",
      "margin-bottom": "10px"
    },
    attrs: {
      "type": "ghost"
    },
    on: {
      "click": _vm.cancelEditingDataRowOnClick
    }
  }, [_vm._v("Отменить")]), _vm._v(" "), _c('Button', {
    class: _vm.editingDataRow.val.id == null ? 'hidden' : '',
    staticStyle: {
      "float": "right",
      "border-radius": "3px",
      "margin-bottom": "10px",
      "padding-top": "5px",
      "color": "#d7d7d7"
    },
    attrs: {
      "type": "ghost"
    },
    on: {
      "click": _vm.deleteEditingDataRowOnClick
    }
  }, [_c('Icon', {
    attrs: {
      "type": "trash-b",
      "size": "18"
    }
  }), _vm._v(" "), (_vm.editingDataRow.val.Deleted == -1) ? _c('Icon', {
    attrs: {
      "type": "ios-redo",
      "size": "18"
    }
  }) : _vm._e()], 1)], 1)]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9c1abc70","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Partners/Partners.vue
// module id = 407
// module chunks = 0